<template>
    <section id="phone-list">
        <div class="row">
            <div class="col-12 col-md-6" v-for="phone in companyInfo.phones">
                <span class="d-block margin-bottom-20">
                    <img class="margin-right-10" height="30" :src="'/assets/flags/'+ phone.flag +'-flag.png'" :alt="'Ultimate Jet Vacations phone number in '+phone.country" />
                    <a :href="phone.phone.getURI()" class="link-style">{{ phone.country }}: <strong>{{ phone.phone.formatInternational() }}</strong></a>
                </span>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                companyInfo: this.$store.getters["Company/companyInfo"],
            }
        }
    }
</script>